const TopbarTitle = () => (
  <div className="TopbarTitle">
    <h1>LibreTODO</h1>
    <h5>A minimal TODO board</h5>
  </div>
);

export default TopbarTitle;
